import React from 'react';

const About = () => {
  return (
      <div className="proskins-content" style={{ padding: 'var(--spacing-lg)', margin: '0px auto' }}>
        <div style={{ marginBottom: 'var(--spacing-sm)' }}>
          <div style={{marginBottom: 'var(--spacing-sm)', display: 'flex', justifyContent: 'space-between'}}>
            <h1 className="proskins-section-title">About</h1>
          </div>
        </div>
        <div className="proskins-card" style={{ marginBottom: 'var(--spacing-2xl)',display: 'flex' }}>
        
          <div className='about-content-container'  style={{marginBottom: 'var(--spacing-sm)', justifyContent: 'space-between'}}>
             <img 
                src="/aboutus.jpg" 
                alt="aboutus" 
                className="proskins-image"
              />
            <h1 className="proskins-section-title">Pro$kin</h1>
            <p>
              Our website was created by a group of passionate golf enthusiasts who share a love for the game, the numbers behind it, and the thrill of competition. What began as casual discussions among friends about golf stats and fantasy sports quickly evolved into a bigger vision: to design a platform that captures the excitement of golf and brings it to life in a brand-new way. We believed that golf, with its strategy, unpredictability, and rich data, deserved a state-of-the-art space where fans could engage more deeply than ever before.
            </p>

            <p>
              At our core, we are driven by an obsession with golf statistics and analytics. We realized that the same attention to detail that drives players on the course could also fuel a unique betting and fantasy sports experience for fans. By studying the game at every level—player performance, course conditions, and tournament dynamics—we’ve built a platform where insights meet entertainment. Our team of developers, golf lovers, and data experts came together to make sure the site is as dynamic and exciting as the sport itself.
            </p>

            <p>
              Unlike traditional fantasy or sports betting platforms, our site is designed exclusively for golf fans, by golf fans. We wanted to break away from cookie-cutter formats and instead merge the best aspects of fantasy sports, stat-driven gameplay, and wagering into one seamless experience. Every feature has been built with the intention of giving players a smarter, more engaging way to enjoy the sport they love. From innovative game formats to interactive tools, we aim to provide a platform that truly stands apart from anything else available today.
            </p>
            <p>
              This isn’t just a gambling site—it’s a community of people who are as passionate about golf as we are. Our mission is to create a place where fans can test their knowledge, enjoy friendly competition, and celebrate the sport’s timeless appeal. Whether you’re a seasoned bettor, a fantasy sports veteran, or a golf fan eager to try something new, we welcome you to join us. Together, we’re building a space where the love of the game meets the excitement of innovation.
            </p>
          </div>
        </div>  
      </div>
  );
};

export default About;
